import { render, staticRenderFns } from "./tixian.vue?vue&type=template&id=440355d6&"
import script from "./tixian.vue?vue&type=script&lang=js&"
export * from "./tixian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports